import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './pledge.less'
import { getI18n } from 'client/i18n'
import MoneyTextBox from 'components/common/money_text_box'
import { exitGlimpse } from 'lib/glimpse'
import { routerShape } from 'react-router/lib/PropTypes'
import { sendEnsightenEvent } from 'lib/ensighten_analytics'
import { trackClick } from 'lib/fpti_analytics'
import { toCFPBStringId } from 'client/lib/cfpb'

const i18n = getI18n('components/chip_in_glimpse/pledge')

class Pledge extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    onPledge: PropTypes.func,
    currency: PropTypes.string,
    handleSubmit: PropTypes.func,
    router: routerShape.isRequired,
  }

  handleSubmit = formValues => {
    sendEnsightenEvent('MoneyPoolPledgeFin')
    return this.props.onPledge(formValues).then(() => {
      trackClick({
        clickName: 'pledge',
        data: {
          amount: formValues.pledge,
          currency: this.props.currency,
        },
      })
      exitGlimpse('chip_in', this.props.router)
    })
  }

  render() {
    const {
      fields: { pledge },
      handleSubmit,
    } = this.props

    return (
      <div>
        <div styleName="title">{i18n('title')}</div>
        <div>{i18n('subtitle')}</div>

        <form onSubmit={handleSubmit(this.handleSubmit)} styleName="form">
          <MoneyTextBox
            {...pledge}
            currencyCode={this.props.currency}
            title={i18n('amount')}
            autoFocus={true}
          />
          <div styleName="text">{i18n(toCFPBStringId('text'))}</div>

          <button className="vx_btn vx_btn-block" styleName="done-button">
            {i18n('pledge')}
          </button>
        </form>
      </div>
    )
  }
}

export default cssModules(Pledge, styles)
